import { QRImages } from "./qr-images";

export { QRImages };
